import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { InjectionToken, Signal, inject, signal } from '@angular/core';
import { BehaviorSubject, Observable, catchError, map, of, tap } from 'rxjs';

export const STATIC_JSON_BASE_URL = new InjectionToken<string>('STATIC_JSON_BASE_URL');

export abstract class BaseHrmLookupClient<T> {
  protected abstract readonly FILE_PATH: string;
  protected readonly _cacheSubject = new BehaviorSubject<T[]>([]);
  protected cache$?: Observable<T[]>;

  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(STATIC_JSON_BASE_URL);
  private readonly _isLoadedSignal = signal(false);
  public readonly isLoadedSignal: Signal<boolean> = this._isLoadedSignal.asReadonly();

  protected getCachedOrFetch(): Observable<T[]> {
    if (this.cache$) {
      return this.cache$;
    } else {
      this.cache$ = this._cacheSubject.asObservable();

      return this.fetch();
    }
  }

  protected abstract mapFileToModel(data: unknown): T[];

  private fetch(): Observable<T[]> {
    return this.http.get(this.baseUrl + this.FILE_PATH).pipe(
      map(this.mapFileToModel.bind(this)),
      tap({
        next: (data: T[]) => {
          this._cacheSubject.next(data);
          this._isLoadedSignal.set(true);
        },
        error: (err: HttpErrorResponse) => {
          console.error(`[hrm-lookup] ${this.FILE_PATH} failed`, err);
          this._isLoadedSignal.set(true);
        },
      }),
      catchError(() => of([] as T[])),
    );
  }
}
